import { render } from "./BagModal.vue?vue&type=template&id=18a174be&scoped=true"
import script from "./BagModal.vue?vue&type=script&lang=js"
export * from "./BagModal.vue?vue&type=script&lang=js"

import "./BagModal.vue?vue&type=style&index=0&id=18a174be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a174be"]])

export default __exports__